import {ComparatorBase, ComparisonTypeEnum} from "./ComparatorBase";
import Select from 'react-select';
import * as React from 'react';
import './MultipleOptionsComparator.css'
import {ConditionLineTypeEnum} from "./ComparatorFactory";
import {Sanitizer} from "shared/utilities/Sanitizer";

export class MultipleOptionsComparator extends ComparatorBase{



    public GetComparator(skipValueLessConditions=false){
        return (
            <select className={this.GetComparisonClass()} value={this.Condition.ConditionLineOptions.Comparison} onChange={x=>this.ComparisonChanged(x.target.value.toString())} style={{height:'auto',padding:0,width:'100%'}} >
                <option value={ComparisonTypeEnum.Contains}>Contains</option>
                <option value={ComparisonTypeEnum.NotContains}>Not Contains</option>
                {!skipValueLessConditions&&<option value={ComparisonTypeEnum.IsEmpty}>Is Empty</option>}
                {!skipValueLessConditions&&<option value={ComparisonTypeEnum.IsNotEmpty}>Is Not Empty</option>}
            </select>
        );
    }

    InitializeValues() {
        this.Condition.ConditionLineOptions.Comparison=ComparisonTypeEnum.Contains;

    }

    public GetValueInput(){
        let condition=this.Condition.ConditionLineOptions;

        const colourStyles = {
            control:(base)=> ({
                ...base,
                width:'100%',
                minHeight:25
            }),
            dropdownIndicator:(base)=> ({
                ...base,
                padding:0
            }),
            indicatorsContainer:(base)=> ({
                ...base,
                minHeight:23,
                padding:0
            }),
            input:(base)=> ({
                ...base,
                height:20,
                lineHeight:'20px',
                minHeight:20

            }),
            multiValue:(base)=> ({
                ...base,
                marginTop:0,
                minHeight:22

            }),
            singleValue:(base)=> ({
                ...base,
               backgroundColor:'red'

            }),
            valueContainer:(base)=> ({
                minHeight:23,
                ...base,
            }),
            placeholder:(base)=> ({
                ...base,
                minHeight:25
            }),
            menuPortal:(base)=>{
                return {...base,zIndex:100000000000}
            },
            menu:(base)=> {
                base.label='menu-multiselect-option'
                return ({
                ...base,
                margin:0,
                padding:2
            })}
        };


        let options=this.GetAvailableOptions();
        let selectedOptions=options.filter(x=>this.Condition.props.ConditionLineOptions.Value.indexOf(x.value)>=0);
        let comparisonType=this.Condition.props.ConditionLineOptions.Comparison;
        return <Select  value={selectedOptions} styles={colourStyles as any} onChange={x=>{this.OnChange(x as any)}} menuPosition={'absolute'} menuPortalTarget={document.body} options={options} classNamePrefix={'rnMultipleComparisonSelect'} className={'rnMultipleComparisonSelect '+this.GetValueClass()} isSearchable={true} isMulti={true} isDisabled={comparisonType==ComparisonTypeEnum.IsEmpty||comparisonType==ComparisonTypeEnum.IsNotEmpty}/>
    }



    private ComparisonChanged(s: string) {
        this.Condition.ConditionLineOptions.Comparison=ComparisonTypeEnum[s];
        this.Condition.forceUpdate();
    }

    private ValueChanged(value: string) {
        this.Condition.ConditionLineOptions.Value=value;
        this.Condition.forceUpdate();
    }

    private GetAvailableOptions():{label:string,value:string}[] {
        let options:{label:string,value:any}[]=[];


        if(this.Condition.props.ConditionLineOptions.Type==ConditionLineTypeEnum.Standard)
        {

            let field=this.ConditionField;
            if(field==null||((field as any).Items==null))
                return options;

            for(let option of (field as any).Items)
            {
                options.push({label:option.Label,value:option.Label});
            }


        }

        return options;
    }

    private OnChange(x: {label:string,value:string}[]) {
        this.Condition.props.ConditionLineOptions.Value=x.map(x=>x.value);
        this.Condition.forceUpdate();
    }


    ValueIsValid(){
        return this.Condition.props.ConditionLineOptions.Comparison==ComparisonTypeEnum.IsEmpty||
            this.Condition.props.ConditionLineOptions.Comparison==ComparisonTypeEnum.IsNotEmpty||
            Sanitizer.SanitizeStringArray(this.Condition.props.ConditionLineOptions.Value).length>0;
    }
    SanitizeValue() {
        this.Condition.props.ConditionLineOptions.Value=Sanitizer.SanitizeStringArray(this.Condition.props.ConditionLineOptions.Value);
    }
}